'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter() {
    _classCallCheck(this, Filter);

    return _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).apply(this, arguments));
  }

  _createClass(Filter, [{
    key: 'onChange',
    value: function onChange() {
      var _props = this.props,
          onChange = _props.onChange,
          debounce = _props.debounce;


      if (onChange) {
        if (debounce) {
          return this.debounce(onChange);
        } else {
          return this.noDebounce(onChange);
        }
      }
    }
  }, {
    key: 'debounce',
    value: function debounce(callback) {
      var _this2 = this;

      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

      var timeout = void 0;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          var val = _this2.refs.field.value;
          callback(val);
        }, delay);
      };
    }
  }, {
    key: 'noDebounce',
    value: function noDebounce(callback) {
      var _this3 = this;

      return function () {
        var val = _this3.refs.field.value;
        callback(val);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          placeholder = _props2.placeholder,
          classNames = _props2.classNames,
          onSubmit = _props2.onSubmit,
          styles = _props2.styles;


      return _react2.default.createElement(
        'form',
        {
          action: '/',
          onSubmit: onSubmit,
          className: 'c11n-filter ' + classNames.root
        },
        _react2.default.createElement(_icon2.default, { name: 'search', size: 1.25, styles: styles.icon }),
        _react2.default.createElement('input', {
          ref: 'field',
          type: 'search',
          'aria-label': placeholder,
          placeholder: placeholder,
          onChange: this.onChange(),
          autoComplete: 'off',
          className: classNames.input
        })
      );
    }
  }]);

  return Filter;
}(_react.Component);

Filter.propTypes = {
  /**
   * The onChange event handler to be fired
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The onSubmit event handler
   */
  onSubmit: _propTypes2.default.func,

  /**
   * The placeholder for the input
   */
  placeholder: _propTypes2.default.string,

  /**
   * The background color for the leaderboard
   */
  background: _propTypes2.default.string,

  /**
   * The foreground color for the leaderboard
   */
  foreground: _propTypes2.default.string,

  /**
   * Custom styles for the component
   */
  styles: _propTypes2.default.object,

  /**
   * Whether or not to debounce the onChange callback
   */
  debounce: _propTypes2.default.bool
};

Filter.defaultProps = {
  placeholder: 'Filter results',
  styles: {},
  debounce: true,
  onSubmit: function onSubmit(e) {
    return e.preventDefault();
  }
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Filter);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/filter/index.js
// module id = 229
// module chunks = 0